<!-- Renderiza V3 si el tema es V3, de lo contrario V2 -->
<app-sales-final-instructions-client-v3 (gotoStepEvent)="gotoStepEvent.emit($event)" *ngIf="isFlowkrdya"></app-sales-final-instructions-client-v3>
<app-sales-final-instructions-client-v2 (gotoStepEvent)="gotoStepEvent.emit($event)" *ngIf="!isFlowkrdya"></app-sales-final-instructions-client-v2>
1
